import { Outlet, useRoutes } from "react-router-dom";
import { lazy } from "react";
import { LoadComponent } from "@loadComponent";
import { RoomHub } from "_pages/client/desk/RoomHub";
import {ListSuspense} from "_pages/client/components/ListSuspense";
import {SuspenseHoursAvailable} from "_pages/client/conference-desk/components/suspense/SuspenseHoursAvailable";

const ConferenceDesk = () => {
    return useRoutes([
        {
            path: ':id',
            children: [
                {
                    path: '',
                    element: <LoadComponent component={lazy(() => import('./List'))} fallback={<ListSuspense />} />,
                }, {
                    path: 'sala/:conferenceDeskId',
                    element: <Outlet />,
                    children: [
                        {
                            path: '',
                            element: <LoadComponent component={lazy(() => import('./HoursAvailable'))} fallback={<SuspenseHoursAvailable />}/>
                        },
                        {
                            path: 'agendado',
                            element: <LoadComponent component={lazy(() => import('./ScheduledConference'))} fallback={<></>}/>
                        },
                        {
                            path: 'atendimento',
                            element: <LoadComponent component={lazy(() => import('./ChatRoom'))} fallback={<></>} />
                        }
                    ]
                }
            ],

        }
    ]);
};


export default ConferenceDesk;
